export const formatCompanyRegistrationNumber = (companyRegistrationNumber: string | undefined | null): string => {
    if (!companyRegistrationNumber) {
        return 'Organisationsnummer saknas';
    }
    const cleaned = companyRegistrationNumber.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `${cleaned.substring(0, 6)}-${cleaned.substring(6)}`;
    }
    return companyRegistrationNumber;
};
